export default __webpack_public_path__ + "static/media/GV-02.bc85df95.png";